export default __webpack_public_path__ + "e3988f5.png";